var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNitroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342 77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M280.283 10h38.704c7.732 0 14 6.268 14 14v30c0 7.732-6.268 14-14 14h-38.704c-7.732 0-14-6.268-14-14V24c0-7.732 6.268-14 14-14Zm3.767 44.196h31.085V23.221l-40.035-.06 8.95 5.252v25.783ZM241.362 10c7.732 0 14 6.268 14 14v12.207c0 7.732-6.268 14-14 14h-2.914L255.6 68l-18.053-.023-18.405-17.77L197.8 50.2l8.946 5.25V68H188V10h53.362ZM206.7 36.413h30V23.068l-38.9.049 8.9 5.223v8.073ZM157.746 68H139V23.685h-21.938V10h62.696v13.685l-31.048.03 9.035 5.302.001 38.983ZM89 10h18.746v58H89V10Zm-31 0h18.746v58H58v-.001l-.001.001-30.013-36.187V68H9.24V10h18.746v.012L28 10l30 35.752V10Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitroLogo);
export default __webpack_public_path__ + "static/media/nitro-logo.40d2cf04857687a87222ed0e54387746.svg";
export { ForwardRef as ReactComponent };